import { TypeTableHead } from "../../../type/componentsType/TkTable";
import TkPropertyMessageGet from "../../../utils/TkPropertyMessageGet";

type ItemType = {
  keyword: string;
  type: string;
  label: string;
  selectPropsList?: { value: string; label: string }[];
};

let searchList: ItemType[] = [
  {
    keyword: "searchKbn",
    type: "selectFrom",
    label: "区分",
    selectPropsList: [],
  },
  {
    label: "共済契約者番号",
    type: "label",
    keyword: "searchContractorNo",
  },
  {
    label: "共済契約者名(ﾌﾘｶﾞﾅ)",
    type: "label",
    keyword: "searchContractorKana",
  },
  {
    label: "施設名",
    type: "label",
    keyword: "searchFacilityName",
  },
  {
    label: "金額",
    type: "label",
    keyword: "searchBillingAmt",
  },
];

const tableHeader: TypeTableHead[] = [
  {
    headTitle: "",
  },
  {
    headTitle: "請求ID",
    align: "left",
  },
  {
    headTitle: "請求日",
    align: "left",
  },
  {
    headTitle: "請求金額",
    align: "left",
  },
  {
    headTitle: "請求先",
    align: "left",
  },
  {
    headTitle: "区分",
    align: "left",
  },
];

const schema = {
  searchContractorNo: {
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 6,
      message: TkPropertyMessageGet("TKMSG_SCR0077E", "6"),
    },
  },
  searchContractorKana: {
    pattern: {
      value: /^[ｧ-ﾝｦﾞﾟ\s-]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0054E"),
    },
    maxLength: {
      value: 144,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "144"),
    },
  },
  searchFacilityName: {
    pattern: {
      value: /^[^ -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    maxLength: {
      value: 20,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "20"),
    },
  },
  searchBillingAmt: {
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0048E", "999,999,999"),
    },
  },
};

export { searchList, tableHeader, schema };
